import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (
    measurementId &&
    measurementId !== "G-XXXXXXXXXX" &&
    measurementId.startsWith("G-")
  ) {
    ReactGA.initialize(measurementId);
    console.log("Google Analytics initialized with ID:", measurementId);
  } else {
    console.warn(
      "Google Analytics Measurement ID not set. Please update your Measurement ID in the environment variables."
    );
  }
};

// Track page views
export const trackPageView = (path) => {
  // For GA4, send page_view event
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value,
  });
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  trackEvent("Button", "Click", buttonName);
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent("Form", "Submit", formName);
};

// Track downloads
export const trackDownload = (fileName) => {
  trackEvent("Download", "File", fileName);
};

// Track external links
export const trackExternalLink = (url) => {
  trackEvent("External Link", "Click", url);
};

// Track Register button clicks specifically
export const trackRegisterClick = () => {
  ReactGA.event({
    category: "button",
    action: "register_click",
    label: "cashflow_register_button",
  });
};
